import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SourceOfRevenueOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const SourceOfRevenueSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(SourceOfRevenueOptions).map((key) => ({
        id: key,
        label: t(`intake_form.source_of_revenue_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default SourceOfRevenueSelect;
